export default [
  { id: 1, value: 'Wheelchair' },
  { id: 2, value: 'Parking' }
]
